import React from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import Utils from 'functions/Utils'
import Chip from '@material-ui/core/Chip';
import { withStyles} from '@material-ui/core/styles';
import {UserUsageApi} from 'config/config';
import axios from 'interceptors';
import './UsageStorage.css'

const StorageCircularProgress = withStyles((theme) => ({
    root: {
        color: "#FF9666",
        height: "8vh !important",
        width: "8vh !important",
        zIndex: "999999"
    }

}))(CircularProgress);

const BackgroundCircularProgress = withStyles((theme) => ({
    root: {
        color: "#3C3C3B",
        height: "8vh !important",
        width: "8vh !important",
        marginLeft: "-8vh"
    }

}))(CircularProgress);

function CircularProgressWithLabel(props) {
    return (
      <Box position="relative" display="inline-flex">
        <StorageCircularProgress variant="determinate" {...props} />
        <BackgroundCircularProgress  variant="determinate" value="100" />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
            
            <Typography variant="caption" component="div" color="textPrimary">
              {props.value}%
            </Typography>
        </Box>
      </Box>
    );
  }

  CircularProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
  };

class UsageStorageContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            intervalId: null,
            storage: {},
            progress: 0,
        };
        
        this.timer = this.timer.bind(this);

        window.usageStorageContainerComponent = this;
    }

    componentDidMount() {
        var intervalId = setInterval(this.timer, 45000);
        this.setState({
            intervalId: intervalId,
            storage: {},
            progress: 0,
        });

        let id =localStorage.getItem('@crabber/username');
        axios({
            url: UserUsageApi.uri + '/' + id + `/online_storage`, 
            method: 'GET',
        }).then(response => {
            if (response.status === 200) {
                let progress = response.data.progress;
                this.setState({
                    storage: response.data,
                    progress: progress,
                });
            }
        })
        .catch(error => {
            console.error(error);
        });
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
        this.setState({
            intervalId: null,
        });
    }

    
    timer() {   
        let id =localStorage.getItem('@crabber/username');
        
        axios({
            url: UserUsageApi.uri + '/' + id + `/online_storage`, 
            method: 'GET',
        }).then(response => {
            if (response.status === 200) {
                let progress = response.data.progress;
                this.setState({
                    storage: response.data,
                    progress: progress,
                });
            }
        })
        .catch(error => {
            console.error(error);
        });
    }

    render() {
        
        return (
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    style={{
                        height: "100%",
                        marginTop: "auto",
                        marginBottom: "auto",
                    }}>
                        <Grid 
                            item
                            style={{
                                marginRight: 10
                            }}
                        >
                        <Typography variant="body1" component="div" color="textPrimary">
                            <b>Espaço usado </b>
                        </Typography>
                        </Grid>
                            <Tooltip 
                                title={
                                    <React.Fragment>
                                        <Typography variant="caption" component="div">
                                            <b>Espaço usado: </b> {Utils.humanFileSize(this.state.storage.current_amount)}
                                        </Typography>
                                        {
                                                (this.state.storage.limit > 0) &&
                                                <div>
                                                    <Typography variant="caption" component="div">
                                                        <b>Espaço restante: </b> {Utils.humanFileSize(Math.max(0, this.state.storage.limit - this.state.storage.current_amount))}
                                                    </Typography>
                                                    <Typography variant="caption" component="div">
                                                        <b>Espaço excedente: </b> {Utils.humanFileSize(this.state.storage.excedeed)}
                                                    </Typography>
                                                </div>
                                        }
                                    </React.Fragment>
                                } 
                                arrow 
                                placement="bottom">
                                <Grid item>
                                    {
                                        (this.state.storage && this.state.storage.limit > 0) ? (
                                            <div>
                                                <CircularProgressWithLabel value={this.state.progress} />
                                            </div>
                                        ) : (
                                            <div>
                                                <Chip label="Ilimitado" />
                                            </div>

                                        )
                                    }
                                </Grid>
                            </Tooltip>
                </Grid>
            
        )
    }
}


function UsageStorage(props) {
    return (
        <div className='usage-storage-container'>
            <UsageStorageContainer />
        </div>
    )
}

export default UsageStorage